import { AccountInfo, InteractionRequiredAuthError, IPublicClientApplication } from '@azure/msal-browser';
import { isProd } from '../env/environment';

export const getApiAccessToken = async (instance: IPublicClientApplication, account: AccountInfo | null): Promise<string> => {
    if (account == null) {
        throw Error("Could not get valid account for fetching an access token")
    }

    const appScope = isProd() ? "https://cqgauth.onmicrosoft.com/282df8fe-27b2-4232-a4f8-434b95ce73f3": "https://cqgauthdev.onmicrosoft.com/f31756af-6166-4b19-9ba9-b38a1579e81a"

    const request = {
        scopes: [`${appScope}/Content.Read`, "offline_access"],
        account: account
    };

    try {
        const response = await instance.acquireTokenSilent(request);
        return response.accessToken
    } catch (error) {
        if (error instanceof InteractionRequiredAuthError) {
            try {
                const response = await instance.acquireTokenPopup(request);
                console.log("Access token acquired via popup:", response.accessToken);
            } catch (popupError) {
                console.error("Failed to acquire token via popup:", popupError);
            }
        } else {
            console.error("Token acquisition failed:", error);
        }
        throw error; 
    }
};